<template>
  <div>

    <div class="congtent">
      <div class="congtentheader">
        <div class="congtentheadertext">{{ swiperList.applicationName }}</div>
      </div>
      <!-- 回显 查询-->
      <div class="congtentmiddle"
        v-if="swiperList.applicationName != '无犯罪记录证明在线查询' && swiperList.applicationName != '空气质量查询'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <el-form-item :label=swiperList.searchTitle prop="name">
            <el-input v-model="ruleForm.name" class="congtentmiddle_toptextinput" :disabled="ifweather" maxlength="30"
              @input="(e) => inputVal('name', e)" clearable></el-input>
          </el-form-item>

          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px;">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')"
                v-if="swiperList.isshow != 1 && swiperList.isshow != 2">查询</div>
              <div class="congtentfooterleft" @click="goQuerytwo('ruleForm')"
                v-if="swiperList.isshow == 1 || swiperList.isshow == 2">查询</div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')">重置</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="congtentmiddle" v-if="swiperList.applicationName == '无犯罪记录证明在线查询'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name" class="congtentmiddle_toptextinput" disabled></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idcrad">
            <el-input v-model="ruleForm.idcrad" class="congtentmiddle_toptextinput" disabled></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px;">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')">查询</div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')">重置</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="congtentmiddle" v-if="swiperList.applicationName == '空气质量查询'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <el-form-item :label=swiperList.searchTitle prop="name">
            <el-input v-model="ruleForm.name" class="congtentmiddle_toptextinput" :disabled="ifweather"
              maxlength="30"></el-input>
          </el-form-item>

          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px;">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')">查询</div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')">重置</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 结果页面 -->
      <div class="congtentresult" v-if="tableList == true" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-loading="loading">
        <div class="contentresulttextheader">
          <div class="contentresulttext">查询结果</div>
        </div>
        <div v-if="tableListadd.length != 0" class="congtentHaveresult" ref="imgBox">
          <div v-for="(item, index) in tableListadd" :key="index" style="margin-top: 20px; display: flex;  flex-wrap: wrap;
  flex-direction: row;">
            <div v-for="items, key in item">
              <div class="congtentHaveresulttopleft">
                <div class="congtentHaveresulttoplefttxt">{{ key }}</div>
                <div class="congtentHaveresulttopleftnumber"
                  v-if="key != '介绍' && key != '内容概述' && key != '基本配置和参数' && key != '医院简介' && key != '警示内容' && key != '摘要'"> {{ 
                  swiperList.applicationName=='公证员查询'|| swiperList.applicationName=='司法鉴定员查询'?(key=='姓名'?desensitizeChineseName(items):items):items
                  }}</div>

                <div class="congtentHaveresulttopleftnumbered"
                  v-if="key == '介绍' || key == '基本配置和参数' || key == '内容概述' || key == '医院简介' || key == '警示内容' || key == '摘要'"> {{ items
                  }}</div>

              </div>
            </div>
          </div>
          <div class="finanCialservicecontentPro" v-if="swiperList.isshow == 1 || swiperList.isshow == 2">
            <el-pagination background layout="total, prev, pager, next, jumper" :total="total" :page-size="10"
              @current-change="handleCurrentChange"></el-pagination>
          </div>
        </div>
        <div v-if="tableListadd.length == 0" class="congtentresultarr">
          <div class="contentresulttextline"></div>
          <img src="../assets/noreslute.png" class="congtentresultimg">
          <div class="congtentresultimgtext">暂无结果</div>
        </div>
      </div>
      <!-- 我要纠错 -->
      <div class="congtentfooterno" @click="gourl()">
        <img src="../assets/bottomicon.png" class="congtentfooternoimg">
        <div class="congtentfooternotext">我要纠错</div>
      </div>
      <div class="congtentfooternotexttwo" v-if="swiperList.isshow != 1 || swiperList.isshow == 2">本服务由大庆市营商环境建设监督局提供
      </div>
      <div class="congtentfooternotexttwo" v-if="swiperList.isshow == 1">本服务由黑龙江省司法厅提供</div>
    </div>


  </div>
</template>

<script>
import appCollection from "@/common/appCollection.js";
import { GVerify } from "@/utils/jqGetCode.js";

import commonUtils from "@/utils/commonUtils.js";
import {
  createsign,
  query,
  switchTicket
} from "@/api/api";
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    var checkinputcode = (rule, inputcode, callback) => {
      console.log(this.verifyCode.options.code.toLowerCase() ,this.ruleForm.inputcode.toLowerCase())
      if (inputcode === '') {
        callback(new Error('验证码不能为空'));
      } else if (inputcode.length !== 4) {

        callback(new Error('验证码长度为4个字符!'));
      } else if (this.verifyCode.options.code.toLowerCase() != this.ruleForm.inputcode.toLowerCase()) {

        callback(new Error('验证码不正确!'));
      } else {
        callback();
      }
    };
    return {
      swiperList: {},
      swiperListOrg: [
        { "applicationName": "大庆市公办养老院查询", "application_id": "getPublicNursingHomes", "searchTitle": "机构名称", "uniqueId": "pc-dqsgbylycxkcnlx" },
        { "applicationName": "大庆市公厕信息查询", "application_id": "getPublicToiletInfo", "searchTitle": "公厕名称", "uniqueId": "pc-dqsgcxxcxidzcj" },
        { "applicationName": "大庆市机动车环检机构查询", "application_id": "getMotorVehicleLoopCheckAgency", "searchTitle": "检测站名称", "uniqueId": "pc-dqsjdchjjgcxjkqpz" },
        { "applicationName": "大庆市公交企业信息查询", "application_id": "getBusCompaniesInfo", "searchTitle": "业户名称", "uniqueId": "pc-dqsgjqyxxcxjepxp" },
        { "applicationName": "大庆市出入境业务受理点查询", "application_id": "getExitEntryBusinessAcceptPoint", "searchTitle": "受理网点", "uniqueId": "pc-dqscrjywsldcxyxsdo" },
        { "applicationName": "大庆市车管所服务网点查询", "application_id": "getDmvServiceOutlets", "searchTitle": "网点名称", "uniqueId": "pc-dqscgsfwwdcxqsvfw" },
        { "applicationName": "大庆市交通违法处理网点查询", "application_id": "getTrafficViolationHandlingOutlets", "searchTitle": "网点名称", "uniqueId": "pc-dqsjtwfclwdcxbfwbj" },
        { "applicationName": "大庆市驾驶证考试服务网点查询", "application_id": "getDriverExamServiceOutlets", "searchTitle": "考试场名称", "uniqueId": "pc-dqsjszksfwwdcxmttkg" },
        { "applicationName": "大庆市机动车检测站查询", "application_id": "getMotorVehicleInspectionStation", "searchTitle": "名称", "uniqueId": "pc-dqsjdcjczcxrkibi" },
        { "applicationName": "大庆市律师事务所基本信息查询", "application_id": "getLawFirmInfo", "searchTitle": "律师事务所名称", "uniqueId": "pc-dqslsswsjbxxcxkpjjs" },
        { "applicationName": "大庆市公证处机构信息查询", "application_id": "getNotaryOfficeInstInfo", "searchTitle": "公证机构名称", "uniqueId": "pc-dqsgzcjgxxcxuktrx" },
        { "applicationName": "大庆市法律援助机构查询", "application_id": "getLegalAidInstInfo", "searchTitle": "机构名称", "uniqueId": "pc-dqsflyzjgcxzolgg" },
        { "applicationName": "大庆市司法鉴定机构查询", "application_id": "getForensicInstInfo", "searchTitle": "机构名称", "uniqueId": "pc-dqssfjdjgcxydfje" },
        { "applicationName": "大庆市A级旅游景区信息查询", "application_id": "getALevelTouristAttractionsInfo", "searchTitle": "景区名称", "uniqueId": "pc-dqsAjlyjqxxcxtuxuh" },
        { "applicationName": "大庆市星级宾馆信息查询", "application_id": "getStarHotelInfo", "searchTitle": "饭店名称", "uniqueId": "pc-dqsxjbgxxcxevdjm" },
        { "applicationName": "大庆市供热企业信息查询", "application_id": "getHeatingCompaniesInfo", "searchTitle": "企业名称", "uniqueId": "pc-dqsgrqyxxcxddlxb" },
        { "applicationName": "大庆市人行天桥信息查询", "application_id": "getPedestrianBridgeInfo", "searchTitle": "桥梁名称", "uniqueId": "pc-dqsrxtqxxcxsopzx" },
        { "applicationName": "大庆市垃圾中转站查询", "application_id": "getGarbageTransferStation", "searchTitle": "中转站名称", "uniqueId": "pc-dqsljzzzcxqdski" },
        { "applicationName": "大庆市车辆管理所查验岗网点查询", "application_id": "getVehicleManageInspectionOutlets", "searchTitle": "网点名称", "uniqueId": "pc-dqsclglscygwdcxgmqbi" },
        { "applicationName": "大庆市畜禽定点屠宰企业查询", "application_id": "getLivestockPoultrySlaughteringEnterprises", "searchTitle": "单位名称", "uniqueId": "pc-dqscqddtzqycxfpfrb" },
        { "applicationName": "大庆市司法局信息查询", "application_id": "getBojInfo", "searchTitle": "单位名称", "uniqueId": "pc-dqssfjxxcxetixz" },
        { "applicationName": "大庆市出租车车辆信息查询", "application_id": "getTaxiVehicleInfo", "searchTitle": "车辆号牌", "uniqueId": "pc-dqsczcclxxcxhktay" },
        { "applicationName": "大庆市客运站基本信息查询", "application_id": "getPassengerStationInfo", "searchTitle": "客运站名称", "uniqueId": "pc-dsskyzjbxxcxspwfx" },
        { "applicationName": "大庆市民办养老院查询", "application_id": "getPrivateNursingHomes", "searchTitle": "机构名称", "uniqueId": "pc-dqsmbylycxdfttc" },
        { "applicationName": "大庆市燃气燃烧器具安装企业查询", "application_id": "getGasBurningUtensilInstalEnterprises", "searchTitle": "企业名称", "uniqueId": "pc-dqsrqrsqjazqycxacpmt" },
        { "applicationName": "大庆市燃气企业基本信息查询", "application_id": "getGasEnterpriseInfo", "searchTitle": "企业名称", "uniqueId": "pc-dqsrqqyjbxxcxywdsy" },
        { "applicationName": "大庆市公交车辆信息查询", "application_id": "getBusVehicleInfo", "searchTitle": "车牌号", "uniqueId": "pc-dqsgjclxxcxptwsa" },
        { "applicationName": "大庆市测速设备点位信息查询", "application_id": "getSpeedTestPointInfo", "searchTitle": "设备名称", "uniqueId": "pc-dqscssbdwxxcxgmxue" },
        { "applicationName": "大庆市律师基本信息查询", "application_id": "getLawFirmInfoNew", "searchTitle": "律师事务所名称", "uniqueId": "pc-dqslsjbxxcxdbupu" },
        { "applicationName": "大庆市强制隔离戒毒所查询", "application_id": "getCompulsoryIsolationDrugRehabilitation", "searchTitle": "单位名称", "uniqueId": "pc-dqsqzgljdscxookea" },
        { "applicationName": "大庆市幼儿园查询", "application_id": "getKindergarten", "searchTitle": "幼儿园名称", "uniqueId": "pc-dqsyeycxmgwok" },
        { "applicationName": "大庆市定点医疗机构查询", "application_id": "getDesignatedMedicalInst", "searchTitle": "医疗机构名称", "uniqueId": "pc-dqsddyljgcxwddbk" },
        { "applicationName": "大庆市儿童医院查询", "application_id": "getChildrenHospital", "searchTitle": "医院名称", "uniqueId": "pc-dqsetyycxoxijk" },
        { "applicationName": "大庆市康复医院查询", "application_id": "getRehabilitationHospital", "searchTitle": "医院名称", "uniqueId": "pc-dqskfyycxfovvu" },
        { "applicationName": "大庆市眼科医院查询", "application_id": "getEyeHospital", "searchTitle": "医院名称", "uniqueId": "pc-dqsykyycxvvqhy" },
        { "applicationName": "大庆市公立医院查询", "application_id": "getGeneralHospital", "searchTitle": "医院名称", "uniqueId": "pc-dqszhyycxabanx" },
        { "applicationName": "大庆市纪念馆查询", "application_id": "getMemorialHall", "searchTitle": "纪念馆名称", "uniqueId": "pc-dqsjngcxrxukd" },
        { "applicationName": "大庆市社保网点查询", "application_id": "getServiceOutlets", "searchTitle": "网点名称", "uniqueId": "pc-dqsbswdcxvuaix" },
        { "applicationName": "大庆市婚姻登记机构", "application_id": "getMarriageRegisterAgency", "searchTitle": "机构名称", "uniqueId": "pc-hydjjgjwasa" },
        { "applicationName": "大庆市医保定点药店查询", "application_id": "getHealthcareFixedPointPharmacy", "searchTitle": "机构名称", "uniqueId": "pc-ybddydqkqor" },
        { "applicationName": "大庆市卫生院查询", "application_id": "getHealthCenter", "searchTitle": "卫生院名称", "uniqueId": "pc-wsyjscnw" },
        { "applicationName": "大庆市工伤保险定点医疗机构查询", "application_id": "getIndustrialInjuryInsuranceFixedPointAgency", "searchTitle": "机构名称", "uniqueId": "pc-gsbxddyljgcxtyzed" },
        { "applicationName": "大庆市民营医院查询", "application_id": "getPrivateHospital", "searchTitle": "医院名称", "uniqueId": "pc-myyycxmpynw" },
        { "applicationName": "大庆市仲裁机构查询", "application_id": "getArbitrationAgency", "searchTitle": "机构名称", "uniqueId": "pc-zcjgcxolkzw" },
        { "applicationName": "无犯罪记录证明在线查询", "application_id": "getNoCriminalRecord", "searchTitle": "机构名称", "uniqueId": "pc-wfzjlzmzxcxnrjbn", "userType": 1 },
        { "applicationName": "空气质量查询", "application_id": "getAirQuality", "searchTitle": "当前时间", "uniqueId": "pc-kqzlcxflpyt" },
        { "applicationName": "大庆市医保定点医疗机构查询", "application_id": "getDesignatedMedicalInst", "searchTitle": "医疗机构名称", "uniqueId": "po-ybddyljgcxyzyxg" },
        // 本服务由黑龙江省司法厅提供
        { "applicationName": "公共法律服务中心", searchType: '1', "application_id": "0101", "searchTitle": "机构名称", "uniqueId": "pc-ggflfwzxogutu", "isshow": 1 },
        { "applicationName": "公共法律服务中心工作人员查询", searchType: '0', "application_id": "0101", "searchTitle": "姓名", "uniqueId": "pc-ggflfwzxgzrydkcsz", "isshow": 1 },
        { "applicationName": "基层法律服务工作者查询", searchType: '0', "application_id": "0307", "searchTitle": "姓名", "uniqueId": "pc-jcflfwgzzcxgppyf", "isshow": 1 },
        { "applicationName": "基层法律服务所查询", searchType: '1', "application_id": "0304", "searchTitle": "机构名称", "uniqueId": "pc-jcflfwscxewesk", "isshow": 1 },
        { "applicationName": "仲裁人员查询", searchType: '0', "application_id": "0401", "searchTitle": "姓名", "uniqueId": "pc-zcrycxhslqz", "isshow": 1 },
        { "applicationName": "司法鉴定员查询", searchType: '0', "application_id": "0303", "searchTitle": "姓名", "uniqueId": "pc-sfjdycxurdbb", "isshow": 1 },
        { "applicationName": "人民调解员查询", searchType: '0', "application_id": "0501", "searchTitle": "姓名", "uniqueId": "pc-rmdjycxusjte", "isshow": 1 },
        { "applicationName": "人民调解机构查询", searchType: '1', "application_id": "0501", "searchTitle": "机构名称", "uniqueId": "pc-rmdjjgcxuzotn", "isshow": 1 },
        { "applicationName": "法律援助人员查询", searchType: '0', "application_id": "0308", "searchTitle": "姓名", "uniqueId": "pc-flyzrycxaaprk", "isshow": 1 },
        { "applicationName": "法律援助中心查询", searchType: '1', "application_id": "0305", "searchTitle": "机构名称", "uniqueId": "pc-flyzzxcxdoesa", "isshow": 1 },
        { "applicationName": "公证员查询", searchType: '0', "application_id": "0302", "searchTitle": "姓名", "uniqueId": "pc-gzycxkabwj", "isshow": 1 },
        { "applicationName": "公证机构查询", searchType: '1', "application_id": "0302", "searchTitle": "机构名称", "uniqueId": "pc-gzjgcxgorri", "isshow": 1 },
        { "applicationName": "律师事务所查询", searchType: '1', "application_id": "0301", "searchTitle": "机构名称", "uniqueId": "pc-lsswscxcvfxi", "isshow": 1 },
        { "applicationName": "律师查询", searchType: '0', "application_id": "0301", "searchTitle": "姓名", "uniqueId": "pc-lscxocahk", "isshow": 1 },
        { "applicationName": "仲裁委员会查询", searchType: '1', "application_id": "0401", "searchTitle": "机构名称", "uniqueId": "pc-zcwyhcxqyvjj", "isshow": 1 },
        { "applicationName": "司法鉴定机构查询", searchType: '1', "application_id": "0303", "searchTitle": "机构名称", "uniqueId": "pc-sfjdjgcxrxjhw", "isshow": 1 },
        // 第二批新加应用searchType：3是一个公共的接口需要单独进行调用。
        // 第二批新加应用searchType：3是一个公共的接口需要单独进行调用。
        { "applicationName": "公厕查询", "application_id": "getPublicToiletInfo", "searchTitle": "公厕名称", "uniqueId": "pc-gccxixpiq" },
        { "applicationName": "公交车信息查询", "application_id": "getBusVehicleInfo", "searchTitle": "车牌号", "uniqueId": "pc-gjcxxcxxcsux" },
        { "applicationName": "森林防火巡查电话查询", "application_id": "getNameAddressSlfh", "searchTitle": "名称", "uniqueId": "pc-slfhxcdhcxheojs" },
        { "applicationName": "乡镇警务查询", "application_id": "getNameAddressPlice", "searchTitle": "名称", "uniqueId": "pc-xzjwcxqehpj" },
        { "applicationName": "汽车票查询", "application_id": "getNameAddressStation", "searchTitle": "终点名称", "uniqueId": "pc-qcpcxolvro" },
        { "applicationName": "美丽乡村", "searchType": "3", "application_id": "mlxc", "searchTitle": "乡村景区名称", "uniqueId": "pc-mlxclxcxf", "isshow": 2 },
        { "applicationName": "15分钟生活圈", "searchType": "3", "application_id": "shq", "searchTitle": "社区名称", "uniqueId": "pc-15fzshqsvldd", "isshow": 2 },
        { "applicationName": "附近充电桩查询", "searchType": "3", "application_id": "fjcdz", "searchTitle": "名称", "uniqueId": "pc-fjcdzcxhyoyn", "isshow": 2 },
        { "applicationName": "附近洗车场查询", "searchType": "3", "application_id": "fjxcc", "searchTitle": "企业名称", "uniqueId": "pc-fjxcccxdytjk", "isshow": 2 },
        { "applicationName": "学区划分查询", "searchType": "3", "application_id": "xqhf", "searchTitle": "学校名称", "uniqueId": "pc-xqhfcxdujrk", "isshow": 2 },
        { "applicationName": "附近汽车维修查询", "searchType": "3", "application_id": "fjqcwx", "searchTitle": "企业名称", "uniqueId": "pc-fjqcwxcxzobvc", "isshow": 2 },
        { "applicationName": "网格员信息查询", "searchType": "3", "application_id": "wgy", "searchTitle": "社区名称", "uniqueId": "pc-wgyxxcxzcntt", "isshow": 2 },
        { "applicationName": "附近药店查询", "searchType": "3", "application_id": "fjyd", "searchTitle": "药店名称", "uniqueId": "pc-fjydcxlchpm", "isshow": 2 },
        { "applicationName": "附近农贸市场查询", "searchType": "3", "application_id": "fjnmsc", "searchTitle": "农贸市场名称", "uniqueId": "pc-fjnmsccxysfod", "isshow": 2 },
        { "applicationName": "附近批发市场查询", "searchType": "3", "application_id": "fjpfsc", "searchTitle": "批发市场名称", "uniqueId": "pc-fjpfsccxfatda", "isshow": 2 },
        { "applicationName": "附近平价超市查询", "searchType": "3", "application_id": "fjpjcs", "searchTitle": "超市名称", "uniqueId": "pc-fjpjcscxqjjzy", "isshow": 2 },
        { "applicationName": "附近加油站查询", "searchType": "3", "application_id": "fjjyz", "searchTitle": "企业名称", "uniqueId": "pc-fjjyzcxcorrj", "isshow": 2 },
        { "applicationName": "附近社区/社区信息公开", "searchType": "3", "application_id": "fjsq", "searchTitle": "社区名称", "uniqueId": "pc-fjsqsqxxgkrzjfe", "isshow": 2 },
        // 以下应用没有数据
        { "applicationName": "预售许可证进度查询", "application_id": "getNameAddressXkz", "searchTitle": "企业名称", "uniqueId": "pc-ysxkzjdcxlfwwr" },
        { "applicationName": "农机购置补贴产销信息查询", "application_id": "getNameAddressNjgzbtXs", "searchTitle": "产品名称", "uniqueId": "pc-njgzbtcxxxcxoiejy" },
        { "applicationName": "农机购置补贴机具产品信息查询", "application_id": "getNameAddressNjgzbtCp", "searchTitle": "机械设备", "uniqueId": "pc-njgzbtjjcpxxcxinzuf" },
        { "applicationName": "农牧政策解读", "application_id": "getNameAddressNmzcjd", "searchTitle": "信息名称", "uniqueId": "pc-nmzcjduqtom" },
        { "applicationName": "医院信息查询", "application_id": "getNameAddressYyxx", "searchTitle": "机构名称", "uniqueId": "pc-yyxxcxcatce" },
        { "applicationName": "廉政警示", "application_id": "getNameAddressLzjs", "searchTitle": "警示标题", "uniqueId": "pc-lzjsjftpw" },
        { "applicationName": "三农服务", "application_id": "getNameAddressSnfw", "searchTitle": "政策名称", "uniqueId": "pc-snfwyszfx" },
        { "applicationName": "农村工作动态", "application_id": "getNameAddressNcgzdt", "searchTitle": "标题", "uniqueId": "pc-ncgzdtkzpjs" },

      ],
      tableListadd: [],
      ruleForm: {
        name: '',
        idcrad: '',
        inputcode: '',
        pageNum: 1
      },
      rules: {
        inputcode: [
          { validator: checkinputcode, trigger: 'blur', required: true, }
        ],
      },
      tableList: false,
      loading: true,
      ifweather: false,
      token: '',
      total: ''

    }
  },
  created() {

    this.getshow()

  },
  mounted() {
    this.verifyCode = new GVerify("auth_code");
  },
  methods: {
    inputVal(type, e) {
      console.log(type)
      let reg =
        /([`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#¥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、～]|[0-9|*|#]\uFE0F\u20E3)|([0-9|#]\u20E3)|([\u203C-\u3299]\uFE0F\u200D)|([\u203C-\u3299]\uFE0F)|([\u2122-\u2B55])|(\u303D)|([(\A9)|(\AE)]\u3030)|(\uA9)|(\uAE)|(\u3030)|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF])|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F])/g;
      setTimeout(() => {
        this.ruleForm[type] = e.replace(reg, "");
      }, 0);
    },

    getshow: function () {
      console.log(appCollection.applicationName)
      var that = this
      var param = {

      }
      param.name = appCollection.applicationName
      if (param.name) {
        that.swiperList = that.swiperListOrg.find(
          item => item.applicationName == param.name
        );

        if (appCollection.applicationName == '无犯罪记录证明在线查询') {

          that.getswitchTicket();
          that.getuserInfo()
        } else if (appCollection.applicationName == '空气质量查询') {
          that.ruleForm.name = that.timeTurn(new Date().getTime());
          that.ifweather = true
        }
        document.querySelector('title').innerText = appCollection.applicationName;

      } else {
        that.swiperList = {};
      }
    },
    getswitchTicket: async function () {
      var that = this;
      let datajson = {};
      let response = await switchTicket(datajson);
      console.log(response);
      if (
        Object.keys(response.data).length == 0 ||
        Object.keys(JSON.parse(response.data.resultDate).data).length == 0
      ) {
        that.$message({
          dangerouslyUseHTMLString: true,
          iconClass: "myicon",
          message:
            '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">请先登录！</div>',
        });
        setTimeout(function () {
          window.open(
            "https://www.zwfw.hlj.gov.cn/api-gateway/hljzwfw-jis-third-server/front/sso/appLogin?redirectUrl= " +
            'https://www.zwfw.hlj.gov.cn/jmopen_files/unzip/d3e26a0ea9304c17a394c02c9d86bd01/pc-wfzjlzmzxcxnrjbn/index.html'

          );
        }, 2000)
      } else {
        that.getuserInfo(JSON.parse(response.data.resultDate).data.ticket);
      }
    },
    getuserInfo: async function (ticket) {
      var that = this
      let sign = null
      let jmContent = commonUtils.sm2doEncrypt(
        ticket
      );
      let datajson = {
        app_id: that.swiperList.uniqueId,
        interface_id: "f38bc28f-6e63-7dda-da33-d44b3ae76b56",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          param: jmContent
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1
      }
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.uniqueId,
        interface_id: "f38bc28f-6e63-7dda-da33-d44b3ae76b56",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          param: jmContent
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
        sign: sign
      }
      let responseInfo = await query(datajsonED)

      if (responseInfo.success && responseInfo.code != 401) {
        let realData = JSON.parse(responseInfo.data);
        let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
        let res = JSON.parse(doDecrypt);
        console.log(res)
        if (res.status == '200') {
          if (res.data.usertype == 2 && that.swiperList.userType == 1) {
            that.$message({
              dangerouslyUseHTMLString: true,
              iconClass: "myicon",
              message:
                '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">本服务仅支持个人账户使用!</div>',
            });
          } else if (res.data.usertype == 1 && that.swiperList.userType == 2
          ) {
            that.$message({
              dangerouslyUseHTMLString: true,
              iconClass: "myicon",
              message:
                '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">本服务仅支持法人账户使用!</div>',
            });

          } else {
            if (res.data.uType == 1) {
              that.loginInfo = res.data
              console.log(that.loginInfo)
              that.ruleForm.name = that.desensitizeChineseName(res.data.username)
              that.ruleForm.idcrad = that.desensitizeIDNumber(res.data.paperCode)
              that.ruleForm.username = that.desensitizeChineseName(res.data.username)
              that.ruleForm.phone = that.phoneNumber(res.data.mobile)
              that.token = res.token
            }

          }

        } else {

          that.$message({
            dangerouslyUseHTMLString: true,
            type: "error",
            message:
              '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">获取用户信息失败</div></div>',
          });
        }



      } else {
        that.$message({
          dangerouslyUseHTMLString: true,
          type: 'error',
          message: '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">获取用户信息失败</div></div>'
        });
      }

    },
    goQuery: async function (formName) {

      var that = this
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true
          that.getData()
        } else {
          console.log('error submit!!');
          return false;
        }
      });


    },
    goQuerytwo: async function (formName) {

      var that = this
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true
          that.getDatatwo()
        } else {
          console.log('error submit!!');
          return false;
        }
      });


    },

    // 姓名脱敏
    desensitizeChineseName(name) {
      if (!name) {
        return "";
      }
      if (name.length <= 1) {
        return name;
      }
      const firstChar = name.charAt(0);
      const starCount = name.length - 1;
      const stars = "*".repeat(starCount);
      return firstChar + stars;
    },
    // 身份证号脱敏
    desensitizeIDNumber(idNumber) {
      if (!idNumber) {
        return "";
      }
      if (idNumber.length < 4) {
        return idNumber;
      }
      const lastFourDigits = idNumber.slice(-4);
      const stars = "*".repeat(idNumber.length - 4);
      return stars + lastFourDigits;
    },
    // 手机号脱敏
    phoneNumber(phoneNumber) {
      // 手机号仅显示前三位及后四位数字，隐藏信息用*代替
      return phoneNumber.substr(0, 3) + '****' + phoneNumber.substring(7);
    },
    resetForm(formName) {
      this.tableList = false
      this.tableListadd = []
      this.$refs[formName].resetFields();
      // this.verifyCode = new GVerify("auth_code");
      this.verifyCode.refresh()
      if (this.swiperList.applicationName == '无犯罪记录证明在线查询') {
        console.log(111111)
        this.getswitchTicket()
      }

    },
    getData: async function () {
      var that = this
      let sign = null
      var dataTempData = {};
      if (
        appCollection.applicationName == "大庆市出租车车辆信息查询" ||
        appCollection.applicationName == "大庆市公交车辆信息查询"||appCollection.applicationName=="公交车信息查询"
      ) {
        dataTempData = {
          carNo: that.ruleForm.name,
          method: appCollection.applicationList.find(
            item => item.applicationName == appCollection.applicationName
          ).application_id
        };
      } else if (appCollection.applicationName == "空气质量查询") {
        dataTempData = {
          method: appCollection.applicationList.find(
            item => item.applicationName == appCollection.applicationName
          ).application_id
        };
      } else if (appCollection.applicationName == "无犯罪记录证明在线查询") {
        dataTempData = {
          token: that.token,
          method: appCollection.applicationList.find(
            item => item.applicationName == appCollection.applicationName
          ).application_id
        };

      } else {
        dataTempData = {
          name: that.ruleForm.name.trim(),
          method: appCollection.applicationList.find(
            item => item.applicationName == appCollection.applicationName
          ).application_id
        };
      }
      console.log(dataTempData)
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(dataTempData));
      let datajson = {
        app_id: that.swiperList.uniqueId,
        interface_id: "e5yuf23-721f-42bd-a5680-58845hkm856",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1
      }
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.uniqueId,
        interface_id: "e5yuf23-721f-42bd-a5680-58845hkm856",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign
      }
      let responseInfo = await query(datajsonED)
      console.log(responseInfo)
      // 查询成功重置验证码
      this.ruleForm.inputcode = ''
      // this.verifyCode = new GVerify("auth_code");
      this.verifyCode.refresh()
      if (responseInfo.code == 200) {
        let realData = JSON.parse(responseInfo.data);
        console.log("转成json", realData);
        // 解密
        let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
        console.log("解密", doDecrypt);
        let res = JSON.parse(doDecrypt);
        console.log(res)
        if (res.code == "20000") {
          that.loading = false
          that.tableListadd = res.data;
          if (that.tableListadd.length == 0) {
            that.tableListadd = []
            that.tableList = true
          } else {
            that.tableListadd = res.data;
            that.tableList = true
          }
        }
      } else {
        that.tableListadd = []
        that.tableList = true
      }
    },
    getDatatwo: async function () {
      console.log(this.swiperList)
      let searchType = appCollection.applicationList.find(
        (item) => item.applicationName == appCollection.applicationName
      ).searchType
      console.log(searchType)
      var dataTempData = {};
      if (appCollection.applicationName == "公共法律服务中心" ||
        appCollection.applicationName == "公共法律服务中心工作人员查询" ||
        appCollection.applicationName == "基层法律服务工作者查询" ||
        appCollection.applicationName == "基层法律服务所查询" ||
        appCollection.applicationName == "仲裁人员查询" ||
        appCollection.applicationName == "仲裁委员会查询" ||
        appCollection.applicationName == "司法鉴定员查询" ||
        appCollection.applicationName == "司法鉴定机构查询" ||
        appCollection.applicationName == "人民调解员查询" ||
        appCollection.applicationName == "人民调解机构查询" ||
        appCollection.applicationName == "法律援助人员查询" ||
        appCollection.applicationName == "法律援助中心查询" ||
        appCollection.applicationName == "律师查询" ||
        appCollection.applicationName == "律师事务所查询" ||
        appCollection.applicationName == "公证员查询" ||
        appCollection.applicationName == "公证机构查询") {
        dataTempData = {
          pageNum: this.ruleForm.pageNum,
          pageSize: 10,
          name: this.ruleForm.name,
          selectType: appCollection.applicationList.find(
            (item) => item.applicationName == appCollection.applicationName
          ).searchType,
          type: appCollection.applicationList.find(
            (item) => item.applicationName == appCollection.applicationName
          ).application_id,
        };
      } else if (searchType == '3') {
        if (appCollection.applicationName == "网格员信息查询") {
          dataTempData = {
            pageNum: this.ruleForm.pageNum,
            pageSize: 10,
            name: this.ruleForm.name,
            type: appCollection.applicationList.find(
              (item) => item.applicationName == appCollection.applicationName
            ).application_id,
          };
        } else {
          dataTempData = {
            pageNum: this.ruleForm.pageNum,
            pageSize: 10,
            name: this.ruleForm.name,
            type: appCollection.applicationList.find(
              (item) => item.applicationName == appCollection.applicationName
            ).application_id,
          };
        }
      }
      else {
        dataTempData = {
          name: this.ruleForm.name,
          method: appCollection.applicationList.find(
            (item) => item.applicationName == appCollection.applicationName
          ).application_id,
        };
      }
      console.log(dataTempData)
      if (searchType === '1' || searchType === '0') {
        // 不同接口的interFaceId不同,这是黑龙江法网的部分接口
        this.getRelatedInformation(dataTempData, "92a74444444444b49eab02f7c8881de183a", searchType)
      } else if (searchType == '3') {
        console.log(111111111)
        this.getRelatedInformation(dataTempData, "0BFC995CE06817A9E0630100007F0AF7", searchType)
      } else {
        this.getRelatedInformation(dataTempData, "e5yuf23-721f-42bd-a5680-58845hkm856",)
      }
    },
    async getRelatedInformation(paramTemplate, interFaceId, searchType) {
      console.log(paramTemplate)
      var that = this
      let sign = null
      let app_id = appCollection.applicationList.find(
        (item) => item.applicationName == appCollection.applicationName
      ).uniqueId;
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(paramTemplate));
      // 生成签名
      let datajson = {
        app_id: app_id,
        interface_id: interFaceId,
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1
      }
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: app_id,
        interface_id: interFaceId,
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign
      }
      let responseInfo = await query(datajsonED)
      console.log("返回值信息", responseInfo)
      // 查询之后清空验证码
      this.ruleForm.inputcode = ''
      // this.verifyCode = new GVerify("auth_code");
      this.verifyCode.refresh()
      if (responseInfo.code == "200") {
        console.log(responseInfo);
        let realData = JSON.parse(responseInfo.data);
        console.log("转成json", realData);
        // 解密
        let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
        console.log("解密", doDecrypt);
        let res = JSON.parse(doDecrypt);
        if (searchType === '1') {
          console.log(111111)
          // 法律机构查询,字段需要英文转中文
          let middle = []
          for (let item of res.data.pageInfo.list) {
            middle.push({
              "机构名称": item.NAME || "暂无数据",
              "地址": item.ADDRESS || "暂无数据",
              "联系电话": item.PHONE || "暂无数据",
            })
          }
          that.loading = false
          that.tableList = true
          that.tableListadd = middle;
          that.total = res.data.pageInfo.total
        } else if (searchType === '0') {

          let middle = []
          for (let item of res.data.pageInfo.list) {
            if (appCollection.applicationName == '公证员查询' || appCollection.applicationName == "基层法律服务工作者查询" || appCollection.applicationName == "律师查询") {
              middle.push({
                "姓名": item.NAME || "暂无数据",
                "执业机构": item.PRACTICE_INSTITUTION || "暂无数据",
                "职业证号": item.PRACTICE_CERT_NUM || "暂无数据"
              })
            } else if (appCollection.applicationName == '人民调解员查询' || appCollection.applicationName == '法律援助人员查询' || appCollection.applicationName == "公共法律服务中心工作人员查询") {
              middle.push({
                "姓名": item.NAME || "暂无数据",
                "执业机构": item.PRACTICE_INSTITUTION || "暂无数据",
                "联系电话": item.PHONE || "暂无数据"
              })
            }
            else if (appCollection.applicationName == "仲裁人员查询") {
              middle.push({
                "姓名": item.NAME || "暂无数据",
                "执业机构": item.PRACTICE_INSTITUTION || "暂无数据",
              })
            } else if (appCollection.applicationName == "司法鉴定员查询") {
              middle.push({
                "姓名": item.NAME || "暂无数据",
                "执业机构": item.PRACTICE_INSTITUTION || "暂无数据",
                "职业证号": item.PRACTICE_CERT_NUM || "暂无数据",
                "联系电话": item.PHONE || "暂无数据"
              })
            }

          }
          that.loading = false
          that.tableList = true
          that.tableListadd = middle;
          that.total = res.data.pageInfo.total
        } else if (searchType === '3') {
          let middle = []
          for (let item of res.data.pageInfo.list) {
            if (appCollection.applicationName == '美丽乡村') {
              middle.push({
                "乡村名称": item.NAME || "暂无数据",
                "区县": item.AREA_NAME || "暂无数据",
                "地址": item.ADDRESS || "暂无数据",
                "介绍": item.desc || "暂无数据",
              })
            } else if (appCollection.applicationName == '15分钟生活圈') {
              middle.push({
                "社区名称": item.NAME || "暂无数据",
                "所属区县": item.AREA_NAME || "暂无数据",
                "相关资讯": item.desc || "暂无数据",
              })
            } else if (appCollection.applicationName == '学区划分查询') {
              middle.push({
                "学校名称": item.NAME || "暂无数据",
                "归属区域": item.AREA_NAME || "暂无数据",
                "学区": item.ADDRESS || "暂无数据",
              })
            } else if (appCollection.applicationName == '网格员信息查询') {
              middle.push({
                "姓名": item.NAME || "暂无数据",
                "区县": item.AREA_NAME || "暂无数据",
                "所属社区/村": item.ADDRESS || "暂无数据",
              })
            } else if (appCollection.applicationName == '附近农贸市场查询') {
              middle.push({
                "企业名称": item.NAME || "暂无数据",
                "所属县区": item.AREA_NAME || "暂无数据",
                "地址": item.ADDRESS || "暂无数据",
              })
            } else if (appCollection.applicationName == '附近社区/社区信息公开') {
              middle.push({
                "社区": item.NAME || "暂无数据",
                "区县": item.AREA_NAME || "暂无数据",
                "联系电话": item.PHONE || "暂无数据",
              })
            } else if (appCollection.applicationName == '附近洗车场查询' || appCollection.applicationName == '附近加油站查询' || appCollection.applicationName == '附近药店查询') {
              middle.push({
                "企业名称": item.NAME || "暂无数据",
                "区县": item.AREA_NAME || "暂无数据",
                "注册地址": item.ADDRESS || "暂无数据",
              })
            } else if (appCollection.applicationName == '附近批发市场查询') {
              middle.push({
                "机构名称": item.NAME || "暂无数据",
                "区县": item.AREA_NAME || "暂无数据",
                "注册地址": item.ADDRESS || "暂无数据",
              })
            } else {
              middle.push({
                "名称": item.NAME || "暂无数据",
                "区县": item.AREA_NAME || "暂无数据",
                "地址": item.ADDRESS || "暂无数据",
              })
            }
            that.loading = false
            that.tableList = true
            that.tableListadd = middle;
            that.total = res.data.pageInfo.total

          }
        } else {
          that.loading = false
          that.tableList = true
          that.tableListadd = res.data;

        }
        if (that.tableListadd.length == 0) {
          that.loading = false
          that.tableListadd = []
          that.tableList = true

        }
      } else {
        that.loading = false
        that.tableListadd = []
        that.tableList = true
      }
    },
    getDatathree: async function () {

    },
    gourl() {
      window.open('https://www.zwfw.hlj.gov.cn/api-gateway/jpaas-jact-web-server/front/mail-write.do?platformIid=779cfa340d3c4b1792664fbb1d0772f6&appname=' + appCollection.applicationName)
    },
    handleCurrentChange(val) {
      this.ruleForm.pageNum = val
      this.getDatatwo()
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.congtent {
  width: 100%;
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  background-color: #F8F8F8;
}

.congtentheader {
  width: 100%;
  height: 172px;
  background: url('../assets/background.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
}

.congtentheadertext {
  color: rgba(255, 255, 255, 1);
  font-size: 40px;
  text-align: left;
  font-family: SourceHanSansSC-bold;
  font-weight: bold;
  margin-left: 22rem;

}

.congtentmiddle {
  width: 1200px;
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: -42px;
  display: flex;
  justify-content: center;
  padding-top: 47px
}

.congtentmiddled {
  width: 1200px;
  height: 446px;
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: -42px;
  display: flex;
  justify-content: center;

}

.congtentmiddle_top {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
}

.congtentmiddle_toptext {
  width: 64px;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  text-align: right;
  font-family: SourceHanSansSC-regular;
}

.congtentmiddle_toptextinput {
  width: 492px;
  height: 50px;
  line-height: 50px;
  background-color: rgba(245, 247, 250, 1);
  text-align: left;
  /* border: 1px solid rgba(228, 231, 237, 1); */
  color: rgba(192, 196, 204, 1);
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-left: 12px;

}

.congtentmiddle_middle {
  display: flex;
  flex-direction: row;
  align-items: center;

  margin: 0 auto;
  margin-top: 24px;
}

.congtentmiddle_bootm {
  display: flex;
  flex-direction: row;
  align-items: center;

  margin: 0 auto;
  margin-top: 24px;
}

.congtentmiddle_toptextinputmiddle {
  width: 340px;
  height: 49px;
  line-height: 49px;
  background-color: rgba(255, 255, 255, 1);
  text-align: center;
  /* border: 1px solid rgba(228, 231, 237, 1); */
  margin-left: 12px;
}

.congtentmiddle_box {
  width: 120px;
  height: 49px;
  background-color: rgba(255, 255, 255, 1);
  text-align: center;
  /* border: 1px solid rgba(228, 231, 237, 1); */
  margin-left: 30px;
}

/deep/.el-form-item__label {
  line-height: 50px !important;
}

/deep/.el-input__inner {
  height: 49px;
  line-height: 49px;
  padding: 0 12;
  border-radius: 0px;
}

/deep/.el-form-item__error {
  color: #F56C6C;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 110%;
  left: 14px;
}

.congtentfooter {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.congtentfooterleft {
  width: 100px;
  height: 50px;
  line-height: 50px;
  border-radius: 4px;
  background-color: rgba(67, 147, 245, 1);
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
}

.congtentfooterleft:hover {
  cursor: pointer;
}

.congtentfooterright {
  width: 100px;
  height: 50px;
  line-height: 50px;
  border-radius: 4px;
  background-color: white;
  text-align: center;
  border: 1px solid rgba(67, 147, 245, 1);
  margin-left: 35px;
  color: rgba(67, 147, 245, 1);
  font-size: 16px;
  color: rgba(67, 147, 245, 1);
  font-size: 16px;

}

.congtentfooterright:hover {
  cursor: pointer;
}

.congtentfooterno {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  margin-top: 40px
}

.congtentfooternoimg {
  width: 16px;
  height: 16px;
}

.congtentfooternotext {
  color: rgba(67, 147, 245, 1);
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-left: 5px
}

.congtentfooternotexttwo {
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px
}

/* 弹窗内容 */
.showtaostMiddle {
  width: 380px;
  height: 83px;

  border-radius: 4px;
  background-color: #EDF5FF;
  border: 1px solid rgba(67, 147, 245, 1);
  position: absolute;
  top: 25px;
  left: 40%;
  display: flex;
  flex-direction: column;

}

.showtaostMiddletop {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 24px;
  margin-top: 15px;
}

.showtaostMiddletoperror {
  width: 26px;
  height: 26px;
}

.showtaostMiddletoptext {
  color: rgba(16, 16, 16, 1);
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-medium;
  font-weight: bold;
  margin-left: 12px;
}

.showtaostMiddlebottom {
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-left: 62px;
  margin-top: 8px;
}

.congtentresult {
  width: 1200px;
  /* height: 310px; */
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.contentresulttext {
  color: rgba(16, 16, 16, 1);
  font-size: 22px;
  text-align: left;
  font-family: SourceHanSansSC-medium;
  margin-left: 30px;
}

.congtentresultarr {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contentresulttextline {
  width: 1140px;
  height: NaNpx;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  margin-top: 16px
}

.congtentresultimg {
  width: 200px;
  height: 138px;
  margin-top: 31px
}

.congtentresultimgtext {
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-top: 35px;
  margin-bottom: 45px
}

.congtentHaveresult {
  width: 1150px;
  background-color: rgba(255, 255, 255, 1);

  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  margin-top: 10px;
  margin-left: 30px;
  margin-bottom: 20px;
}

.congtentHaveresulttop {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

}

.congtentHaveresulttopleft {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #EBECEC;
  margin-bottom: -1px;
  margin-left: -1px;


}

.congtentHaveresulttoplefttxt {
  width: 188px;
  background-color: rgba(245, 246, 248, 1);
  text-align: left;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-left: 14px;
  padding-top: 30px;
  padding-bottom: 30px;
  overflow: auto;


}

.congtentHaveresulttopleftnumber {
  width: 342px;
  height: 60px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-left: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: auto;





}

.congtentHaveresulttopleftnumbered {
  width: 342px;
  height: 60px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-left: 14px;
  display: flex;
  flex-direction: row;
  overflow: auto;
}

.congtentresultimage {
  margin: 0 auto
}
</style>
<style  lang="scss">
.el-message {
  display: flex;
  width: 380px;
  height: 83px;
  line-height: 20px;
  border-radius: 4px;
  background-color: #EDF5FF !important;
  text-align: center;
  border: 1px solid rgb(67, 147, 245) !important;
  align-items: flex-start !important;
}

.myicon {
  width: 26px;
  height: 26px;
  background-image: url("../assets/mess.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.el-message p {
  margin-top: 7px !important;
}

.finanCialservicecontentPro {
  margin: 0 auto;
  margin-top: 42px;
}
</style>